const lang = {
  title_page: process.env.MIX_APP_NAME,
  form: {
    title: 'パスワード再設定',
    password: '新しいパスワード',
    password_placeholder: '新しいパスワードを入力',
    password_confirmation: '新しいパスワード',
    password_confirmation_placeholder: '新しいパスワードを再度入力',
    submit_button: '登録',
    password_description: '※ 半角英数字10文字以上',
  },
}

export default lang
